/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit StateIcon/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromFlow from 'Simple/Flow'
import * as fromHelpers from './helpers.js'
import No from './No/index'
import NoShow from './NoShow/index'
import React from 'react'



/** @type {import('Simple/types.js').View} */
export default function StateIcon({
  children,
  viewPath = "/DesignSystem/TimeGrid/FullCalendarTimegrid/Appointment/StateIcon"
  
}) {
  let flowValue = fromFlow.useFlowValue(viewPath) || 'No'
let eventStateValueData = fromData.useDataFormat({ viewPath,
context: 'event',
path: 'state',
format: fromHelpers.getView,
})
fromData.useSetFlowToBasedOnDataValue({ viewPath,
value: eventStateValueData,
})
  return (<React.Fragment
>
<fromFlow.When is={flowValue === 'No'}>
<No
  viewPath={`${viewPath}/No`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'NoShow'}>
<NoShow
  viewPath={`${viewPath}/NoShow`}
/>
</fromFlow.When>
{children}
</React.Fragment>)
}